import Swiper from 'swiper'

export default class Naitei2022 {
  constructor() {
    console.log('single-naitei2022')
    this.slider = document.querySelector('.js-slider')
    this.swiper
    this.isSet = false
    this.breakPoint = 992
    this.init()
  }
  checkBreakPoint() {
    if (this.breakPoint <= window.innerWidth && this.isSet) {
      console.log('destory')
      this.swiper.destroy(false, true)
      this.isSet = false
    } else if (this.breakPoint > window.innerWidth && !this.isSet) {
      console.log('set')
      this.setSwiper()
      this.isSet = true
    }
  }
  init() {
    this.checkBreakPoint()
    window.addEventListener('resize', () => {
      this.checkBreakPoint()
    })
  }
  setSwiper() {
    this.swiper = new Swiper(this.slider, {
      speed: 600,
      // autoplay: 500,
      loop: true,
      slidesPerView: 1.4,
      centeredSlides: true,
      spaceBetween: 10,
      loopAdditionalSlides: 12,
      observer: true,
      observeParents: true,
    })
  }
}
